/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { Capabilities } from "./capabilities.js";
export { SandboxedModule };
class SandboxedModule {
    sandbox;
    capabilities;
    modules;
    constructor(sandbox, capabilities, modules) {
        this.sandbox = sandbox;
        this.capabilities = capabilities;
        this.modules = modules;
    }
    async #run(method, name, inputs, telemetry) {
        const invocationId = crypto.randomUUID();
        Capabilities.instance().install(invocationId, this.capabilities, telemetry);
        await telemetry?.startModule();
        const outputs = await this.sandbox.runModule(invocationId, method, this.modules, name, inputs);
        await telemetry?.endModule();
        Capabilities.instance().uninstall(invocationId);
        return outputs;
    }
    async invoke(name, inputs, telemetry) {
        return this.#run("default", name, inputs, telemetry);
    }
    describe(name, inputs) {
        return this.#run("describe", name, inputs);
    }
}
//# sourceMappingURL=module.js.map